import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { markWriteBackSkipped } from "@/api/writeBackManagement";

export function useMarkWriteBackSkipped() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (writeBackId: string) => markWriteBackSkipped(writeBackId),
    onSuccess: () => {
      toast.success("Write-back marked as skipped");
      queryClient.invalidateQueries({ queryKey: ["errored-write-backs"] });
      queryClient.invalidateQueries({ queryKey: ["encounter-write-backs"] });
      queryClient.invalidateQueries({ queryKey: ["encounter-breakdown"] });
    },
    onError: (error) => {
      toast.error(`Failed to mark as skipped: ${error.message}`);
    },
  });
}
